import Orders from "../symbols/orders";

export interface IState {
  selectedTab: number;
}
const initialState: IState = {
  selectedTab: 0
};

function OrdersReducer(state = initialState, action: any) {
  switch (action.type) {
    case Orders.SET_SELECTED_TAB:
      return { ...state, selectedTab: action.payload };
    default:
      return state;
  }
}
export default OrdersReducer;
